<template>
  <v-container v-if="personal">
    <v-row>
      <v-col cols="8">
        <div class="text-h6 font-weight-bold">Lugar donde radica actualmente</div>
      </v-col>
      <v-col cols="4">
        <v-row>
          <v-col cols="12">
            <v-autocomplete
              v-model="personal.fk_idMunicipioRadica"
              rounded
              filled
              dense
              background-color="primary"
              color="secondary"
              :items="municipios"
              item-value="id"
              item-text="nombre"
              item-color="secondary"
            >
              <template v-slot:label>Municipio donde radica</template>
              <template v-slot:item="{ item }">
                <v-list-item-content>
                  <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.catEstado.title }}</v-list-item-subtitle>
                </v-list-item-content>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="8">
        <div class="text-h6 font-weight-bold">Dirección</div>
        <v-card color="transparent" height="480" v-if="$route.matched.some(({ path }) => path === '/enlace_c3')">
          <v-card-text style="height: 480px">
            <MglMap
              :accessToken="accessToken"
              :mapStyle="mapStyle"
              :center="center"
              :zoom="16"
              :bearing="-17.6"
              :antialias="true"
              v-on:dblclick="updateUbicacion($event)"
              :doubleClickZoom="false"
              @load="mapLoaded"
            >
              <MglMarker
                :coordinates="[personal.Contacto.Direccion.lgt, personal.Contacto.Direccion.lat]"
                color="unidad.color"
                :key="personal.idPersonal"
              />
              <MglGeocoderControl
                :accessToken="accessToken"
                :input="defaultInput"
                @results="handleSearch"
                placeholder="Buscar lugar o dirección"
              />
            </MglMap>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-form v-model="direccionForm" ref="direccion">
          <v-row>
            <v-col cols="12">
              <v-autocomplete
                v-model="personal.Contacto.Direccion.fk_idMunicipio"
                rounded
                filled
                dense
                background-color="primary"
                color="secondary"
                :items="municipios"
                item-value="id"
                item-text="nombre"
                item-color="secondary"
              >
                <template v-slot:label>Municipio donde vive</template>
                <template v-slot:item="{ item }">
                  <v-list-item-content>
                    <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                    <v-list-item-subtitle>{{ item.catEstado.title }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12">
              <BaseInput
                v-model="personal.Contacto.Direccion.calle"
              >
                <template v-slot:label>Calle</template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput
                v-model="personal.Contacto.Direccion.entrecalles"
                label="Entre calle"
              ></BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput
                v-model="personal.Contacto.Direccion.entrecalles2"
                label="Entre calle 2"
              ></BaseInput>
            </v-col>
            <v-col cols="6"
              ><BaseInput
                v-model="personal.Contacto.Direccion.ext"
              >
                <template #label>Número exterior</template>
              </BaseInput>
            </v-col>
            <v-col cols="6">
              <BaseInput
                v-model="personal.Contacto.Direccion.int"
                label="Número interior"
              ></BaseInput>
            </v-col>
            <v-col cols="8">
              <BaseInput
                v-model="personal.Contacto.Direccion.colonia"
              >
                <template #label>Colonia</template>
              </BaseInput>
            </v-col>
            <v-col cols="4">
              <BaseInput
                v-model="personal.Contacto.Direccion.cp"
              >
                <template #label>Código Postal</template>
              </BaseInput>
            </v-col>
            <v-col cols="12">
              <BaseInput
                v-model="personal.Contacto.Direccion.referencias"
                label="Referencias"
              ></BaseInput>
            </v-col>
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import MglGeocoderControl from 'vue-mapbox-geocoder'
import Mapbox from 'mapbox-gl'
import { MglMap, MglMarker } from 'vue-mapbox'
import { mapGetters } from 'vuex'
import BaseInput from '../../../base/BaseInput.vue'
import { PERFILES } from '@/perfiles.js'

export default {
  components: {
    MglMap,
    MglMarker,
    MglGeocoderControl,
    BaseInput,
  },
  created() {
    this.mapbox = Mapbox
    if (this.personal && this.personal.Contacto && !this.personal.Contacto.Direccion) {
      this.personal.Contacto.Direccion = {
        calle: '',
        entrecalles: '',
        entrecalles2: '',
        ext: '',
        int: '',
        colonia: '',
        cp: '',
        referencias: '',
        fk_idMunicipio: 0,
        lat: 0,
        lgt: 0,
      }
    }
  },
  data() {
    return {
      PERFILES,
      direccionForm: false,
      accessToken: process.env.VUE_APP_MAPBOX_TOKEN,
      mapStyle: 'mapbox://styles/mapbox/streets-v11',
      defaultInput: '',
    }
  },
  computed: {
    ...mapGetters('personal', {
      personal: 'getPersonalSingle',
    }),
    ...mapGetters({
      perfil: 'getPerfil',
    }),
    ...mapGetters('municipio', {
      municipios: 'getMunicipios',
    }),
    center() {
      if (
        this.personal &&
        this.personal.Contacto &&
        this.personal.Contacto.Direccion &&
        this.personal.Contacto.Direccion.lat != 0
      ) {
        return [this.personal.Contacto.Direccion.lgt, this.personal.Contacto.Direccion.lat]
      }
      return [-98.2460645, 19.3165631]
    },
  },
  methods: {
    updateUbicacion(e) {
      this.personal.Contacto.Direccion.lat = e.mapboxEvent.lngLat.lat
      this.personal.Contacto.Direccion.lgt = e.mapboxEvent.lngLat.lng
    },
    handleSearch(event) {
      // Puedes implementar lógica si necesitas manejar el resultado del geocoder
    },
    mapLoaded(event) {
      // Puedes implementar lógica si necesitas cuando el mapa esté listo
    },
  },
}
</script>
